import { BareActionContext } from 'vuex-typex'
import { FeedState } from '../state'
import { RootState } from '../..'
import feedStore from '../feed-store'
import convoStore from '../../convo/convo-store'

export default async function viewConvos(context: BareActionContext<FeedState, RootState>)
{
  feedStore.commitSetFeedType({ type: 'convo-feed', columns: 2 })
  convoStore.dispatchSetConvoQuery()

  return
}
